<template>
    <common-modal v-if="isOpen" height="smaill" @close="emitEvent({ name: 'close' })">
        <common-content-spacer height="medium">
            <div>
                <h2 class="head">Request Details - {{ requestDetails.requestId }}</h2>
                <div class="main-data-layout">
                    <div class="provider-detail">
                        <p>Provider</p>
                        <span>{{ requestDetails.provider }}</span>
                    </div>
                    <div class="provider-detail">
                        <p>Status</p>
                        <span style="background: #eaf3fc; color: #3182ce; border-radius: 5px; padding: 2px 8px">
                            {{ requestDetails.status }}
                        </span>
                    </div>
                </div>
                <div class="provider-detail">
                    <p>Request Date</p>
                    <span>{{ requestDetails.requestDate }}</span>
                </div>
                <div class="provider-detail">
                    <p>Requested Records</p>
                    <span>{{ requestDetails.requestedRecords }}</span>
                </div>
                <div class="provider-detail">
                    <p>HIPAA Authorization</p>
                    <span>{{ requestDetails.hipaaAuthorization }}</span>
                </div>
                <div class="provider-detail">
                    <p>Notes</p>
                    <span>{{ requestDetails.notes }}</span>
                </div>
            </div>
        </common-content-spacer>
    </common-modal>
</template>

<script>
    export default {
        props: {
            isOpen: { type: Boolean, required: true },
        },
        data() {
            return {
                requestDetails: {
                    requestId: 'REQ002',
                    provider: 'Downtown Clinic',
                    status: 'Received',
                    requestDate: '10/01/2025',
                    requestedRecords: 'Lab Results',
                    hipaaAuthorization: 'General HIPAA Authorization',
                    notes: 'Blood work from last month',
                },
            }
        },
        methods: {
            emitEvent(payload) {
                this.$emit(payload.name)
            },
        },
    }
</script>
<style>
    .provider-detail p {
        font-size: 14px;
        font-weight: 500;
        color: oklch(0.145 0 0);
    }
    .provider-detail {
        margin-bottom: 20px;
        width: 360px;
    }
    .provider-detail span {
        font-size: 12px;
        font-weight: 400;
        color: oklch(0.145 0 0);
    }
    .main-data-layout {
        display: flex;
    }
    .head {
        margin-top: 0;
        margin-bottom: 16px;
        font-size: 16px;
        font-weight: 600;
        color: oklch(0.145 0 0);
    }
    .status-label {
        display: inline-block;
        background: #eaf3fc;
        color: #3182ce;
        border-radius: 12px;
        font-size: 14px;
        font-weight: 500;
        padding: 2px 12px;
        margin-left: 6px;
        vertical-align: middle;
    }
    .common-content-spacer {
        height: 24px;
    }
</style>
